import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import styled, {css} from 'styled-components';
import { Context } from "../context";
import uniqid from "uniqid";

export function MenuDay(props) {
  const context = useContext(Context);
  return (
    <div className="c_h0">

              <div className="c_h_sub">
                <div className="c_h_left">
                  <div className="c_h_today">
                    <Link to="/calendar/today" className="x_button">
                      <div>Today</div>
                    </Link>
                  </div>
                  <div className="c_h_nextprev">
                    <div className="x_cal_lr">
                      <div className="x_cal_l">
                        <div>chevron_left</div>
                      </div>
                      <div className="x_cal_l">
                        <div>chevron_right</div>
                      </div>
                    </div>
                  </div>
                  <div className="c_h_date0">
                    <div className="c_h_date">{context['state']['activeDate']}</div>
                  </div>
                </div>
                <div className="c_h_right">
                  <div className="c_h_nextprev" />

                </div>
              </div>
            </div>
  )
}